import { render } from "./VibrantProductTabs.vue?vue&type=template&id=0e0312e2&scoped=true"
import script from "./VibrantProductTabs.vue?vue&type=script&lang=js"
export * from "./VibrantProductTabs.vue?vue&type=script&lang=js"

import "./VibrantProductTabs.vue?vue&type=style&index=0&id=0e0312e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e0312e2"]])

export default __exports__